export const SERVICE_TYPES = {
  massage: { label: 'Massage', tax: 2500 },
  pt: { label: 'PT', tax: 600 },
  yoga: { label: 'Yoga', tax: 600 },
} as const;
